/**
 * Extracts all unique text strings from a JSON string or object.
 * Searches recursively for properties with the key "text" and aggregates their values,
 * cleaning and deduplicating them.
 * Returns a single concatenated string of unique texts.
 *
 * @param {string | object} jsonString - The JSON string or object to extract text from.
 * @returns {string} - A single string of unique text values.
 */

export const extractText = (jsonString) => {
    if (!jsonString) return '';

    const parsed = typeof jsonString === 'object' ? jsonString : JSON.parse(jsonString);

    function recursivelyExtractText(obj, uniqueTextsSet = new Set()) {
        if (Array.isArray(obj)) {
            obj.forEach((item) => recursivelyExtractText(item, uniqueTextsSet));
        } else if (typeof obj === 'object' && obj !== null) {
            Object.entries(obj).forEach(([key, value]) => {
                if (key === 'text' && typeof value === 'string') {
                    const cleanedValue = value.trim().replace(/\s+/g, ' ');
                    uniqueTextsSet.add(cleanedValue);
                } else if (typeof value === 'object') {
                    recursivelyExtractText(value, uniqueTextsSet);
                }
            });
        }
        return uniqueTextsSet;
    }

    const bodyRaw = parsed.body_raw || parsed;
    const bodyParsed = typeof bodyRaw === 'object' ? bodyRaw : JSON.parse(bodyRaw);

    const uniqueTextsSet = recursivelyExtractText(bodyParsed);
    return Array.from(uniqueTextsSet).join(' ').trim();
};
